export default __webpack_public_path__ + "static/media/TheWorldJapan_07.85f37316.png";